import * as React from "react";
import Hls from "hls.js/dist/hls.light.min";
import { useParams } from "react-router-dom";
import { Page } from "ui/components";
import { Channel } from "core/models";
import getChannelURL from "utils/getChannelURL";
import { listChannels } from "core/services/site/channel";
import { useSessionContext } from "ui/context/SessionContext";
import styles from "./Livestream.module.scss";

interface Params {
    [key: string]: string | undefined;
    channelName: string;
}

const Livestream: React.FC = () => {
    const { channelName } = useParams<Params>();
    const sessionContext = useSessionContext();
    const videoRef = React.useRef<HTMLVideoElement>(null);
    const [channel, setChannel] = React.useState<Channel | null>(null);

    React.useEffect(() => {
        const loadChannel = async () => {
            if (
                !sessionContext.session ||
                !sessionContext.selectedProject ||
                !channelName
            ) {
                return;
            }
            const channels = await listChannels(
                sessionContext.session.token,
                sessionContext.selectedProject.id,
            );
            const currentChannel = channels.value?.find(
                (c) => c.exStream.name === channelName,
            );
            if (!videoRef.current || !currentChannel) {
                return;
            }
            if (Hls.isSupported()) {
                const player = new Hls();
                player.attachMedia(videoRef.current);
                player.loadSource(getChannelURL(channelName));
                player.on(Hls.Events.MANIFEST_PARSED, () => {
                    videoRef.current?.play();
                });
            }
            setChannel(currentChannel);
        };

        loadChannel();
    }, [channelName, sessionContext.session, sessionContext.selectedProject]);

    return (
        <Page padding={false} centered>
            <div className={styles.container}>
                {channel && (
                    <div className={styles.channel__name}>
                        <span>Watching channel: {channel.exStream.name}</span>
                    </div>
                )}
                <video ref={videoRef} controls />
            </div>
        </Page>
    );
};

export default Livestream;
